var humiUpdateAnchor = setInterval(() => {
    let e = document.querySelectorAll(".humi-job-board-posting-link a");
    e.length > 0 &&
      (e.forEach(function (e) {
        e.innerText = 'view job'
      }),
      clearInterval(humiUpdateAnchor));
  }, 100);

let img = document.createElement('img');

img.src = 'https://cdn.shopify.com/s/files/1/0861/9609/3201/files/ping.png?v=1748291674';

img.alt = 'Image description';
img.width = 20;
img.height = 20;

var humiUpdateDescription = setInterval(() => {
    let deets = document.querySelectorAll(".humi-job-board-posting-details");
    deets.length > 0 &&
      (deets.forEach(function (ele) {
        ele.classList.add('fs-sm');
        let newText = 'in-office • ';

        if (ele.innerText.includes('vancouver')) {
            newText += 'vancouver, bc';
        } else if (ele.innerText.includes('el segundo')) {
            newText += 'el segundo, ca';
        } else if (ele.innerText.includes('remote')) {
            newText += 'remote';
        } else {
            newText += 'other';
        }

        ele.innerHTML = '';

        ele.appendChild(img.cloneNode(true));
                
        ele.innerHTML += newText

      }),
      clearInterval(humiUpdateDescription));
  }, 100);